<template lang="pug">
  InlineSvg(:src="require(`../assets/img/svg/${name}.svg`)" :class="{ colored }" :title="title" :style="style")
</template>

<script>
import InlineSvg from 'vue-inline-svg';

export default {
  name: 'CommonIcon',
  components: { InlineSvg },
  props: {
    name: String,
    pointer: Boolean,
    title: String,
    colored: Boolean,
  },
  computed: {
    style() {
      return {
        cursor: this.pointer ? 'pointer' : 'auto',
      };
    },
  },
};
</script>

<style scoped lang="scss">
  .colored::v-deep *[stroke] { stroke: currentColor }
  .colored::v-deep *[fill] { fill: currentColor }
</style>
